import { set, toggle } from '@/utils/vuex'

export default {
  setCrashCoursePaymentList (state, data) {
    state.crashCoursePaymentList = data
  },
  setCrashCourseList (state, data) {
    state.crashCourseList = data
  }
}
